import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { getUserToken } from './Common'

const BgcPublicRoute = () => {
    const isLoggedIn = getUserToken()

    if (isLoggedIn) {
        return <Navigate to="/bgc/dashboard" replace />
    }

    return <Outlet />
}

export default BgcPublicRoute